import React from "react";
import { ItemUserAdminPanel } from "./ItemUserAdminPanel";
import { observer } from "mobx-react-lite";
import { ContainerSubTitleGrey } from "../ContainerSubTitleGrey";

export const ListUserAdminPanel = observer(
  ({
    users,
    actionSuperUser,
    actionActiveUser,
    showSuperuserCol,
    showArchive,
    gridClass,
    emptySearch,
  }) => {
    if (!users?.length) {
      return (
        <ContainerSubTitleGrey
          text={
            emptySearch
              ? "Не найдено пользователей, удовлетворяющих запросу."
              : "В базе нет пользователей"
          }
        />
      );
    }

    return users.map((user) => (
      <ItemUserAdminPanel
        actionActiveUser={actionActiveUser}
        actionSuperUser={actionSuperUser}
        key={user.id}
        user={user}
        showSuperuserCol={showSuperuserCol}
        showArchive={showArchive}
        gridClass={gridClass}
      />
    ));
  },
);
